<template>
  <div :class="['business-info-full-screen-page', readPretty && 'read-pretty']">
    <popup ref="popup"
      class="full-page"
      fullScreen
      :visible="true">
      <businessinfo
        :type="type"
        :shop-id="$route.query.shopId"
        :form-data="formData"
        use-type="component"
        @confirm="updateData"
        @back="hide"
      />
    </popup>
  </div>
</template>
<script>
import popup from '@/components/Popup'
import businessinfo from './businessinfo.vue'

export default {
  name: 'FullScreenBusinessInfo',
  components: {
    popup,
    businessinfo
  },
  props: {
    // businessinfo, businessinfo, padinfo
    type: {
      required: false,
      type: String,
      default: 'businessinfo'
    },
    formData: {
      required: false,
      type: Object,
      default () {
        return {}
      }
    },
    readPretty: {
      default: false
    }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      this.$emit('cancel')
      setTimeout(() => {
        this.remove()
      }, 200)
    },
    updateData (data) {
      this.$emit('confirm', data)
    }
  }
}
</script>

<style lang="scss">
.business-info-full-screen-page {
  position: relative;
  overflow: hidden;
  height: 100%;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }

  &.read-pretty {
    .biz-time {
      button {
        display: none;
      }
    }

    .rich-select {
      pointer-events: none;
      background-color: #f2f2f2;
    }

    .rich-radio-input,.rich-radio-wrap {
      pointer-events: none;

      .rich-radio-content {
        opacity: 0.5;
      }
    }

    .submit-wrap {
      display: none;
    }
  }
}
</style>
